import { render, staticRenderFns } from "./TeamTasksRanking.vue?vue&type=template&id=d20f7018&"
import script from "./TeamTasksRanking.vue?vue&type=script&lang=js&"
export * from "./TeamTasksRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports